module.exports = (require("./helpers/browser/import-polyfill")(require('./helpers/bundle-manifest').resolve("2BXEZ"))).then(() => parcelRequire('2VSx5'));